import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateModelObjectService } from './update-model-object.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [UpdateModelObjectService]
})
export class UpdateModeObjectModule { }
